<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0" v-show="tables.steps.items.length">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.steps.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CContainer :fluid="true">
                                    <CRow>
                                        <CCol>
                                            <ButtonBack 
                                                class="mr-3" 
                                                title="Go back" 
                                                :to="{
                                                    name: 'creativity',
                                                }"
                                            />
                                        </CCol>
                                        <CCol>
                                            <TableSettings
                                                :allFields="
                                                    tables.steps.allFields
                                                "
                                                :activeFields.sync="
                                                    tables.steps.fields
                                                "
                                            />
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.steps.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.steps.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.steps.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.steps.sorterValue"
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.steps.rows"
                                    v-bind="tables.steps"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.steps
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'step_config',
                                                                params: {
                                                                    stepId: tables
                                                                        .steps
                                                                        .itemSelected
                                                                        .uuid,
                                                                    uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("edit_step")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'step_builder',
                                                                params: {
                                                                    stepId: tables
                                                                        .steps
                                                                        .itemSelected
                                                                        .uuid,
                                                                    templateId:
                                                                        uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("open_editor")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            cloneStep(
                                                                tables.steps
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("clone")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            deleteStep(
                                                                tables.steps
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("delete")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.steps.itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'steps',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #order_step="{ item }">
                                        <td class="py-2">
                                            Step {{ item.order_step }}
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.steps.total_pages > 0">
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.steps.page"
                                    :pages="tables.steps.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import ButtonBack from "£lement/ButtonBack";
import FilterFields from "~/components/FilterFields";
import TableSettings from "£lement/TableSettings";
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilCopy,
    cilMediaPlay,
} from "@coreui/icons";
import { mapGetters } from "vuex";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
export default {
    name: "CreativityPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonBack,
        FilterFields,
        TableSettings
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilMediaPlay,
        cilCopy,
    },
    data() {
        return {
            tables: {
                steps: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            sortable: false,
                            active: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: true,
                            filter: false,
                            _style: "width:5%",
                            _filter: true,
                        },
                        {
                            key: "order_step",
                            label: "name",
                            sorter: true,
                            filter: true,
                            _filter: false,
                        },
                        {
                            key: "created_at",
                            label: "created_at",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "updated_at",
                            label: "updated_at",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        }
                    ],
                    items: [],
                    order: "asc",
                    page: 1,
                    rows: 10,
                    allFields: [],
                    total_pages: 1,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    columnFilter: true,
                    itemsPerPageSelect: true,
                    columnFilterValue: {},
                    itemSelected: null,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {
                        column: "order_step",
                        asc: true,
                    },
                },
            },
        };
    },
    computed: {
        template_id: function () {
            return this.$route.params.templateId;
        },
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "steps",
                url: "/templates.api/" + this.uuid + "/steps",
            });
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        async cloneStep(item) {
            await this.fetcher({
                url: `/templates.api/${this.uuid}/steps/${item.uuid}/clone`,
                method: "POST",
            });
            this.updateData();
        },

        async deleteStep(item) {
            await this.deleteData({
                url: `/templates.api/${this.uuid}/steps/${item.uuid}/delete`,
            });
            this.updateData();
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style>
</style>